$(document).ready(function () {
    if($('.banner-list .banner_box').length > 1){  
      $('.banner-list').slick({
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true
      });    
    }

    $('.review-badge-fade').slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToShow: 1,
        fade: true,
        cssEase: 'linear'
    });
    $('.review-slider-list').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });
    $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });
    $('.announcement-marquee__content').marquee({
      direction: 'left',
      duration: 20000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true,
      pauseOnHover: true
    });

    $(".product-slider").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 3
            }
        },
        {
            breakpoint: 750,
            settings: {              
              slidesToScroll: 1,
              slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {              
              slidesToScroll: 1,
              slidesToShow: 1
            }
        }
       ]
    });

    $(".mobile-category-slider").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
        {
            breakpoint: 480,
            settings: {              
              slidesToScroll: 1,
              slidesToShow: 1
            }
        }
       ]
    });

    $(".you-also-like-products").each(function () {
        var $section = $(this);

        $section.find(".you-also-like-slider-list").slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $section.find(".you-like-nav .prev-nav"),
            nextArrow: $section.find(".you-like-nav .next-nav"),
            responsive: [
              {
                  breakpoint: 750,
                  settings: {              
                    slidesToScroll: 1,
                    slidesToShow: 1
                  }
              },
              {
                  breakpoint: 480,
                  settings: {              
                    slidesToScroll: 1,
                    slidesToShow: 1
                  }
              }
            ]
        });
    });

    $('.footer-block--menu > h2').on('click', function (e) {

        e.preventDefault();

        var $parent = $(this).closest('.footer-block--menu');

        if ($parent.hasClass('active')) {
            $parent.removeClass('active');
        } else {
            $('.footer-block--menu').removeClass('active');
            $parent.addClass('active');
        }

    });

    $(document).on('click', '#MegaMenu > .list-menu > li > details > summary', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $currentDetails = $(this).closest('details');

        // Close all other top-level menu details
        $('#MegaMenu > .list-menu > li > details')
            .not($currentDetails)
            .removeAttr('open');

        // Toggle current menu
        if ($currentDetails.is('[open]')) {
            $currentDetails.removeAttr('open');
        } else {
            $currentDetails.attr('open', '');
        }
    });

      var $menuRows = $('.mega_menu_blocks.menu_style01 .mega_menu_list > details.menu_row');

      $menuRows.on('toggle', function () {
        var $this = $(this);
        if (this.open) {
          // close all other open siblings
          $this.siblings('details.menu_row[open]').each(function () {
            this.open = false;
          });
        }
      });
});



// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.product-slider').slick('refresh');
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-slider').slick('refresh');
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");


$(".cart-recommendation-grid").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 3,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    }
  ]
});

const stickyMenuToggle = document.querySelector('.sticky-menu-toggle');
const menuDrawer = document.querySelector('#Details-menu-drawer-container summary');

if (stickyMenuToggle && menuDrawer) {
  stickyMenuToggle.addEventListener('click', function (e) {
    e.preventDefault();

    menuDrawer.click();
  });
}

document.addEventListener('change', function (e) {
  if (!e.target.matches('.main-product-section .product__info-wrapper variant-selects .product-form__input input')) return;

  const variantTitle = document.querySelector('.main-product-section .inventory_threshold .selected-variant-title');

  if (variantTitle) {
    variantTitle.textContent = e.target.value;
  }
});

document.addEventListener('change', function (e) {
  if (!e.target.matches('.quick-add-modal .product__info-wrapper variant-selects .product-form__input input')) return;

  const variantTitle = document.querySelector('.quick-add-modal .product__info-wrapper .inventory_threshold .selected-variant-title');

  if (variantTitle) {
    variantTitle.textContent = e.target.value;
  }
});


async function updateCheckoutButton() {
    const cart = await fetch('/cart.js').then(r => r.json());

    const btn = document.querySelector('.custom_checkout_btn');

    if (btn) {
        btn.textContent = `Checkout - ${Shopify.formatMoney(cart.total_price)}`;
    }
}

const originalFetch = window.fetch;

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url = args[0].toString();

    if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
    ) {
        setTimeout(updateCheckoutButton, 200);
    }

    return response;
};

updateCheckoutButton();

